// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__xhehn","buttons":"RemoveExpirationActionButtons_buttons__2ddQx"};